/*
 * ur-buy.js — shared add-to-basket helper for the reference-guide buy buttons
 * (snippets/guide-buy-buttons.liquid) and the Traumeel selector
 * (sections/traumeel-selector.liquid).
 *
 * The theme's own cart event bus is private to theme.min.js, so we can't open
 * its quick-cart drawer directly. Instead we add via the Ajax Cart API, update
 * the header basket total ourselves, and show a small confirmation toast.
 */
(function () {
  if (window.URBuy) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  var money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
    style: 'currency',
    currency: currency
  });

  function formatCents(cents) {
    return money.format(cents / 100);
  }

  // Labels come from snippets/ur-buy-strings.liquid; English is the fallback.
  function t(key, vars) {
    var all = window.URBuyStrings || {};
    var lang = (window.URBuyLocale || document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    var s = (all[lang] && all[lang][key]) || (all.en && all.en[key]) || key;
    Object.keys(vars || {}).forEach(function (k) {
      s = s.split('{' + k + '}').join(vars[k]);
    });
    return s;
  }

  function refreshHeader(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.setAttribute('data-cart-count', cart.item_count);
      var m = el.querySelector('.money');
      if (!m) return;
      m.textContent = formatCents(cart.total_price);
      // Currency Converter Plus stamps processed prices and appends its own
      // converted copy; clear both so it re-converts the new total.
      if (m.hasAttribute('data-cbb-price-processed')) {
        m.removeAttribute('data-cbb-price-processed');
        var next = m.nextElementSibling;
        if (next && next.classList.contains('currency-converter-wrapper-amount-box')) next.remove();
      }
    });
  }

  var toast, toastTimer;
  function showToast(text, isError) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ur-buy-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML =
      '<span class="ur-buy-toast__msg"></span>' +
      (isError
        ? ''
        : '<a class="ur-buy-toast__link" href="' + root + 'cart"></a>' +
          '<a class="ur-buy-toast__btn" href="' + root + 'checkout"></a>');
    toast.classList.toggle('is-error', !!isError);
    toast.querySelector('.ur-buy-toast__msg').textContent = text;
    if (!isError) {
      toast.querySelector('.ur-buy-toast__link').textContent = t('viewBasket');
      toast.querySelector('.ur-buy-toast__btn').textContent = t('checkout');
    }
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 6000);
  }

  function add(variantId, quantity, title, button) {
    var label = button && button.textContent;
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Could not add to basket');
          return j;
        });
      })
      .then(function () {
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        refreshHeader(cart);
        showToast(t('toast', { title: title }));
        if (button) {
          button.classList.remove('is-loading');
          button.classList.add('is-added');
          button.textContent = t('added');
          setTimeout(function () {
            button.disabled = false;
            button.classList.remove('is-added');
            button.textContent = label;
          }, 2500);
        }
      })
      .catch(function (err) {
        if (button) {
          button.disabled = false;
          button.classList.remove('is-loading');
          button.textContent = label;
        }
        showToast(err.message, true);
      });
  }

  window.URBuy = { add: add, formatCents: formatCents, t: t };
})();
